var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photo"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 200.18,
    cy: 201.09,
    r: 26.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.18,117.79l-15.3,16.7h-26.4c-9.2,0-16.7,7.5-16.7,16.7v100c0,9.2,7.5,16.7,16.7,16.7h133.3 c9.2,0,16.7-7.5,16.7-16.7v-100.1c0-9.2-7.5-16.7-16.7-16.7h-26.4l-15.2-16.6H175.18z M200.18,242.79c-23,0-41.7-18.7-41.7-41.7 s18.7-41.7,41.7-41.7s41.7,18.7,41.7,41.7S223.18,242.79,200.18,242.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.18,101.09h200v200h-200V101.09z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.12b9ee15f99dc4a90659ddc7bf503482.svg";
export { ForwardRef as ReactComponent };